import { Fragment } from '@fragment/Fragment';

// eslint-disable-next-line @typescript-eslint/typedef
export const FragmentsQueueEvents = {
  fragmentsReleased: 'fragmentsQueue.fragmentReleased',
} as const;

export type TFragmentsQueueEvents = {
  [FragmentsQueueEvents.fragmentsReleased]: Fragment[];
};
